import { createSelector } from '@ngrx/store';

import { getCycleModuleState, getSelectedCycle } from './cycle.selectors';

export const getSelectedDiscountId = createSelector(
  getCycleModuleState,
  (state) => state.selectedDiscountId,
);

export const getSelectedDiscount = createSelector(
  getSelectedCycle,
  getSelectedDiscountId,
  (cycle, discountId) => cycle.discounts.find((d) => d.id === discountId),
);
